<template>
  <div>
      <el-select v-model="platform" placeholder="请选择">
    <el-option
      v-for="item in platformList"
      :key="item.value"
      :label="item.name"
      :value="item.value">
    </el-option>
  </el-select>
   <el-button
      type="success"
      @click="search"
      >查询</el-button
    >
    <el-button
      type="primary"
      @click="openDialog()"
      >添加子类目</el-button
    >
     <el-button
      type="success"
      @click="refresh"
      >同步</el-button
    >
    <el-table
      :data="typeList"
      :header-cell-class-name="'table-header'"
      v-loading="is_loading"
      row-key="id"
      :tree-props="{ hasChildren: 'hasChildren', children: 'childList' }"
    >
      >

      <el-table-column label="ID" prop="id"></el-table-column>
      <el-table-column label="名称" prop="name"> </el-table-column>s
      <el-table-column label="图片" prop="">
        <template slot-scope="scope">
          <el-image :src="scope.row.icon" style="width: 3rem"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="排序" prop="sort_order"> </el-table-column>
      <el-table-column label="平台" prop="">
        <template slot-scope="{row}">
         {{getNameByValue(platformList,row.platform)}}
        </template>
      </el-table-column>

      <el-table-column label="操作" prop="" width="180px">
        <template slot-scope="scope">
          <!-- <el-button type="danger" size="small" @click="if_delete(scope.row)"
            >删除</el-button
          > -->
          <el-button type="warning" size="small" @click="edit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :total="typeTotal"
      :size="10"
      :current-page="currentPage"
      @current-change="changeCurrentPage"
    >
    </el-pagination>

    <!-- 新增 -->
    <el-dialog title="添加类目" :visible.sync="addVisible" width="40%">
      <div class="dialog-body">
        <el-form :model="form" id="new-good-form" :rules="rules">
          <el-form-item label-width="8rem" label="分类名称" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="所属平台" required>
          <el-radio v-for="(item,i) in platformList" :key="i" v-model="form.platform" :label="item.value">{{item.name}}</el-radio>
        </el-form-item>
          <el-form-item label-width="8rem" label="排序" prop="categories_child">
            <el-input
              v-model="form.sort_order"
              placeholder="值越大排序越前"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="8rem" label="图片">
            <avatar-uploader
              @getImgUrl="(v) => (form.url = v)"
              :clear="if_clear"
            ></avatar-uploader>
          </el-form-item>
          <el-form-item label-width="8rem" label="类目级别">
            <el-radio v-model="form.level" :label="1">一级类目</el-radio>
            <el-radio v-model="form.level" :label="2">二级类目</el-radio>
          </el-form-item>
          <el-form-item label-width="8rem" label="父类目" v-if="form.level == 2">
            <el-select
              v-model="form.parent_id"
            >
              <el-option
                v-for="item in addTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="addNewType()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改类目 -->
    <el-dialog title="修改类目" :visible.sync="updateVisible" width="40%">
      <div class="dialog-body">
        <el-form :model="form" id="new-good-form" :rules="rules">
          <el-form-item label-width="8rem" label="类目名称" prop="name">
            <el-input v-model="form.name" :placeholder="temp.name"></el-input>
          </el-form-item>
          <el-form-item label-width="8rem" label="类目图片" prop="name">
            <avatar-uploader
              @getImgUrl="(v) => (form.url = v)"
              :url="temp.icon"
            ></avatar-uploader>
          </el-form-item>
          <el-form-item label-width="8rem" label="排序" prop="categories_child">
            <el-input
              v-model="form.sort_order"
              placeholder="值越大排序越前"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateVisible = false">取 消</el-button>
        <el-button type="primary" @click="update()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {platformList} from './dict.js'
export default {
  props: {
    source: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      platformList,
      temp: {},
      is_loading: false,
      if_clear: false,
      addVisible: false,
      updateVisible: false,
      bindVisible: false,
      deleteId: null,
      confirmDelete: false,
      currentPage: 1,
      typeTotal: 0,
      typeList: [],
      categories_list: [],
      form: {},
      addTypeList: [],
      rules: {},
      haveCate: [],
      platform:1,
    };
  },

  mounted() {
    this.load()
  },

  methods: {
    refresh(){
       let url = "/chat/category/refreshData";
          this.$axios({url, params:{
           platform: this.platform
        }})
        .then((res) => {
           this.$message({ type: "warning", message: "同步成功!" });
            this.getTypeList();
        });
    },
    if_delete(row) {
      this.temp = row;
      this.$confirm('确认删除类目吗？').then(()=>{
        this.deleteType()
      })
    },
    deleteType() {
      let url = "/chat/category/delete";
      this.$axios
        .post(url, {
          id: this.temp.id,
          status: 1,
        })
        .then((res) => {
           this.$message({ type: "warning", message: "删除成功!" });
            this.getTypeList();
        });
    },
    load() {
      this.getTypeList();
    },
    changeCurrentPage(v) {
      this.currentPage = v;
      this.getTypeList();
    },
    openDialog() {
      this.addVisible = true;
      this.form.platform = this.platform
    },
    addNewType() {
      this.if_clear = false;
      let data = {
        name: this.form.name ? this.form.name : null,
        parent_id: this.form.parent_id ? this.form.parent_id : null,
        icon: this.form.url,
        level: this.form.level,
        platform: this.form.platform
      };
      let url = "/chat/category/insert";
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "添加成功!" });
        this.form = {};
        this.addVisible = false;
        this.if_clear = this.if_clear;
        // this.refresh();
      });
    },
    search(){
      this.currentPage = 1;
      this.getTypeList();
    },
    getTypeList() {
      this.is_loading = true;
      let url = "/chat/category/queryManagerListPage";
      this.$get(url, {platform: this.platform})
        .then((res) => {
          this.is_loading = false;
          this.typeList = res.data.data.rows;
          this.addTypeList = res.data.data.rows
        });
    },
    update() {
      let url = "/chat/category/update";
      this.$axios
        .post(url, {
          id: this.temp.id,
          name: this.form.name ? this.form.name : null,
          icon: this.form.url ? this.form.url : null,
          sort_order: this.form.sort_order ? this.form.sort_order : null,
        })
        .then((res) => {
          this.$message({ type: "success", message: "更新成功!" });
          this.temp = {};
          this.form = {}
          this.updateVisible = false;
          this.refresh();
        });
    },
    edit(row) {
      this.updateVisible = true;
      this.temp = Object.assign({},row);
      this.form = Object.assign({},row);
    },
  },
};
</script>